import { method, resource } from "./apiRequest"

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const fetchDataProduction = async ({ sales_order }) => {
  const formData = new FormData();
  formData.append("sales_order", sales_order);

  const res = await method.post('sopwer_erp2.sopwer_erp2.page.visualize_production.visualize_production.get_process_data', formData)

  return res.data;
};

export const fetchSalesOrder = async () => {
  const res = await resource.get(`Sales Order`, '["*"]');
  return res.data;
};

export const fetchWorkOrder = async ({salesOrders}) => {
  const filters = JSON.stringify([["sales_order", "=", salesOrders]]);
  const fields = JSON.stringify(["*"]); 
  const res = await resource.get("Work Order", fields, filters); // <-- kirim langsung string

  return res.data;
};



export const getSalesOrder = async ({ user }) => {
  const formData = new FormData();
  formData.append('user', user)
  const res = await method.post('arkha.api.sales_order.get_sales_orders', formData)
  return res.data;
}

export const fetchSalesOrderDetail = async (name) => {
  const res = await resource.get(`Sales Order/${name}`, '["*"]');
  return res.data;
};

export const fetchCustomerByUser = async (user) => {
  const res = await resource.get('Customer', '["*"]', `[["Portal User","user","=","${user}"]]`);
  return res.data;
};
